<div class="w-full h-[50vh] flex justify-center items-center">
    <div class="bg-tw-lightgrey p-8 rounded-lg flex flex-col justify-center items-center gap-2">
        <mat-icon *ngIf="code === '404'" class="scale-150">help</mat-icon>
        {{ message | uppercase | translate }}
    </div>
</div>